var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagCa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "M32 16c0-6.343-3.692-11.824-9.044-14.412v28.824C28.309 27.824 32 22.343 32 16M0 16c0 6.343 3.692 11.824 9.044 14.412V1.588C3.691 4.176 0 9.657 0 16M18.783 18.087l2.782-1.391L20.174 16v-1.391L17.39 16l1.392-2.783H17.39L16 11.13l-1.391 2.087h-1.392L14.61 16l-2.783-1.391V16l-1.391.696 2.782 1.39-.695 1.392h2.782v2.087h1.392v-2.087h2.782z"
})));
export default SvgFlagCa;